import React, { Component } from 'react';
import {
  Layout, Menu, Card, Row, Col, Table, Input, Button, Space, Upload, message, Modal, Form,
  Select,
  InputNumber,
  Switch,
  Slider,
  Rate,
  Spin,
  List,
  Checkbox, Divider, Image,
} from 'antd';
import {
  DownloadOutlined,
  MenuFoldOutlined,
  LeftOutlined,
  RightOutlined,
  LoadingOutlined,
  SyncOutlined,
  CloseOutlined,
  DeleteOutlined,
  PrinterOutlined,
} from '@ant-design/icons';
import { FaSignature } from 'react-icons/fa';
import { IoTrashBin } from 'react-icons/io5';
import { MdClear } from 'react-icons/md';
import SignatureCanvas from 'react-signature-canvas';
import styles from './index.module.css'
import './index.css'
import { connect } from 'react-redux';
import { fabric } from 'fabric';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import Container from '../Layout/Container';
import PdfjsComponent from './pdfjsComponent'
import { pdfjs, PDFDownloadLink } from 'react-pdf';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { UploadSignedDocumentAsyn, UploadSignedDocumentV2Asyn, getIncryptedPDF, EncrptyPdfDataDelAsyn, clearAddResponseState, documentSignatureSelector, clearState, getDocumentDetailAsyn, getDocumentDetailV2Asyn, unsetDocumentDetailStateAsync, getSignatureListAsyn, clearSignatureListState } from './DocumentSignatureSlice';
import history from "../../history";
import { Link } from "react-router-dom";
pdfjs.GlobalWorkerOptions.workerSrc = `pdf.worker-2.9.359.min.js`;

const { Header, Sider, Content } = Layout;
const { Option } = Select;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const { Search, TextArea } = Input;
const data = [
  {
    id: 2,
    image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQwAAABZCAYAAADLuBpjAAAAAXNSR0IArs4c6QAAEeZJREFUeF7tnWnoPVUZx7/WG22xxTKSoA3EtM0WrTct0EK0LwqRVpYkaWZFEe1Z2Cuz1agsy7IMlVYNAqWi3cxKSiuCSiuxQotEX1QYHz3Pv6fjzL0z956ZOXPnOXC59ze/M3POec4533n2s5eiBAXKUOAZkh4l6WhJ10vaT9LvJX1b0jvLNBFPmZoCe03dgWh/1hS4q6R3SDpS0gErRvJLSadIOmfWo43OKwAjFsEmFHi4pJMkvbTnzZ+TdFTPe6J6RRQIwKhoMmbQleckoHhCS1+vlfQ3Sd+TtE8ST/KqiCxnz2Cs0cUGCgRgxLLoQgE4CUSP+7VU/kMCgVMl/T2rA0fxWXftW5Ke2KXRqFMfBQIw6puTmnq0DihQaL5f0pfXdPpESR9MdVCE3r+mQUZfulMgAKM7rZZUEx3FpyTx3VS+koACbqFLOVgSik/KXyXt3+WmqFMfBQIw6puTKXtkVo/XtHTirGQihUvoU9B5fNPdEOuuD/UqqhsTV9FkTNwVuIkvtegpPpA4ir5AYUO6p6S/BGBMPMMFmg/AKEDEHXgEjlUoNfOC6AG3sSlQeMC4StLe6QIiCaJJlJlRIABjZhNWuLtYPd4nCXOpLz9PQNFVR9GlW/+QtG+qeIikK7rcFHXqokAARl3zMWZvmkQQzKNYPfiULugwzH8Ds2pJMCrd13heCwUCMJa5NAAEPDV92VZPsY6SXuw5SNKv190Q/6+PAgEY9c3JkD1CBMFc6j01ET/wt/jZkA1LOk3Sa5M+JPwwBib2UI8PwBiKsvU9FxEEsQDTKQWdAgrNT4/U1SslwVl8UtKxI7UZzRSmQABGYYJW+Di4CsQP860AKBBJxgw5x8sTb09K6C8qXCRduxSA0ZVS86yHqIEVxLiKMyW9u4CZtA81XizpQ8lC8hFJJ/S5OerWRYEAjLrmo1Rv8hgQYj64tq0/xSb9u1TSI1Pbh4X/xSYkrOeeXQQMWO0x2e16ZvNWfwo4Ch9ViqJxCDNpl3F7UeRwSZd0uSnq1EuBXQMMs/XzJiUnA39fPNGbdaxZR9x4dgJJDxSYSQHOPNx8rH4dIenc1NjrEpCN1Xa0MxAFdhUwcnLhJARbTsTkDyT9cSB6jvlYgMKUmaajoP1NA8RK9p38nuhLiCH5kaTHlHx4PGs6CuwaYEBJ3mynp8XaRFliGC6UdLWkt09H+o1btohSdBLeREpOCiwhU3EUfkC/S2JR5L7YeJrrvHEXAcMo/XRJD5b0Kkn3aSH/byW9TNJ36pye2/QKHQWOVx4ozJW7BqDIw9jDhDqThdW1m7sMGJ4GgMIrJKF4aypkvT6vK9EmqAdAoMz0SXeHduXuO8ycszt5wcrnvrSbTf2lAIZNCIv6Ey5q0k8UGxLlXG0ld+fG8QpOo6bgLUTA4xPhAF771EbL6M+WFFgaYECuO0siz0NTItraOA04i586MylxH4DFFP4UTUsNjgdHMBP5agXdLbdJ3G4UWCJg2NjxTyAgKi+1yN1wFpiFzVRK6DnxIDXoKugHHpsWE4L1CV1RTVxP7PIBKLBkwICcmP++ltH1X2kznDEAvbs+Es6CdHkWVQpY8LsGzgJLDNm5TPF6XKLhNV0HF/XmS4GlAwYz5x2M/EziP8Bb9CcTTG+er4Jw8KnBAlEIoLBM4uhScAybyot0gmmJJgMwbl0DvL0/JunAhiXxcUl8xgKOXFSa0rUbcuRAwbVSuT5jB86MAgEY/z9haPoBD7iOvKD5/4KkLw44x+grcHqywsbM820O2PyeR9MP3M0RP7y7OaIRis7QVYwxCxW2EYBx20m5u6RXJ7dr73JtNYc0G+KtyUal3JRORB9LyYmoQdsAVH6A0ZC5PivcFiu7ZGvCvpvmh/9NLUIOQtcAjHayEv9wTHL4aqpFPAqKScClROFtjlnSCm0PnQ0L7oF2H98AEugoADD7lBhjn2fYhvQcDtfYoHzzuTl9+3V8X0mYn+8o6UnpN+0yRoDPnks97rs+cVH2TOr6dvr0uWtdwIRxeLDht13nOfnfzIdd69pO8XoBGOtJioiCqNIkpnC3RcbCpuNqvgm7nosiBMq1nZC+vseraxgngc8JRxj6MgRIMDY2J5vQOBeu5RvUrq3qvW0a22hN3zyX/KQcnET+DeaDerRtb30DHduAHiD8/+y6bWDrm9XJr/M34/BA4Mfpx8Z1A0PPtfjrBl7Uu4u72cDGj8fABhrxGzClnqfZ1txqAEa/7fcsSY+Q9JIVJ5ljNUD30Ac4vCjCBPvF3a+HzbURM0zcyMUs3rpwMvRh00TAvL1Z1Hzou4GDb4t2bFH7N+mqt23ThixBjzk/ow1sbUwGOAZUOXgxV0Q0M9cG5vxNPdYsyY7gnnEvuC4nVADG5ksHYj96TWRsF30HmxnRxkoJqwjcycMSl9KkNGXzAhCEoF/ekQS2EHkuoGDgYG9JuCLPRtub3YNDx6ai2sAU8JyN56IAEcRivrEK/iJZDy+yWKsAjDIzgwPYWyU9oCWsHuL/UxLp6hBbfpVYRTYTkwPLTkH2bjsxPWdnqQebam8cQMLe8k2jMnEDbmId9+O5BQMerhmXYP3m24ChDCXjKbVQ4ABJf05rFq6DeT45AKPs9NwtWVdg+zbRQXw3TZCxkfmbYBUgNI0EAGKiAYk2ccNzCmZO5ds4Bu6zz05q/ssugZ182tmSXiTpggCM4eaXTfdQSc9Noss9JN1uRWKfTXvitedsbHv78ztXchkAoYMB3PgbYANU+HCv3b9pf+K+3aHAvSXh+v8CSZyHe1wAxriTyyZFe404Qb6Ix6Xm/538LoikbeMU2PwGCKYrWCVaGBjwbWIFXIPpFMxkG1zDuGug5tbuJenQZF0iCJMXHn5JFNbLMQEY00xfbkb1yWa8ZaGPGczEINNlAE5elEDJGeAwzXzX2iprjfXyJkkPSqkf8r7yUjonhUfc4rgSZXwKgNaIBRREitx236VHcCmABFYQ05fAQZh40SSSdHlu1FkGBQgcxNTepGQnXcH5bi3toUgAxviLA1THu9BKn1R25kthXIQpNeEe1lk+xh9ptDglBXIrGuuOOKC9JSEC53luEZUxn35+lYdxAMb4U+pD17skxTGQgJNg0nEKM4AIEWP8+Ru7RXOuol3vlMXf3mqW/69PP/EX+nqXUIQAjD5k3b4uk0o0qukp2rgLOAhElhwkAIo+eo3texxPGIICtrnxozHPWNv822z8vn3lrNtvSPpq1xsDMLpSqkw9WEKOCbCCYtL7XAAS1DE/CHPZDpAoQ/8hn2IiAG0YCPjf9pLo4phXup+IrhQioC9LXpsbibABGKWnZvXzmCQUlRSOCSBSFJEDkICr8HEdQ4sbtI1mnOMXiB24NvVrP+ePQR+uSPoRTjHj9xKKxWHw7b1p/aY3TsB8W7rQBQU3z+MwLbwovbLbXgrWRv6SMBfu/LoPRPPRrOZTU/RlE4DRZZrL1MlNqbCB+GEwB4ga6DY2Df7q28M8LSFgges6CxrAWLUJAD3AA0ee30i60YlYflHbb3uWj/BkMfsYBvqfbxT+/lMKU8//13UTWDtGnzzwztrl+n/S2JvqrKOvD6zz8TQ+sG6suV3X163+H4CxFfl63Yyt+z3uDpSXFtfRdQP0anBFZTTilO9LekuDhYWwd4AAJx5ySlC4BkhgcvOAAZubbzIfIr4NYMD53Knh+fTH4m82pYl5yNr99qbO//bXPRhQb3Gm6wCMTZdbt/vYSKaXeIik26fb3iDp1G6PGKSWAQa2eBSvu1IMuIx7yb/HBuZdoeuecQRglJ9SlFpm5bBs34gfb3NNeWVn+R6sfyKKV/QmyNHPSyesr78raiyeAgEYZZaAxW2cJAmQgFU1Xwl+e+vIVIl9/UgBNMSjx6aLiBpLUWiWmfGFPiUAY7OJByD2lUSyGwCCYrkhmvJw+oxaY+Tq7DIqchyQn8PKk5OnX5d7o85CKRCA0W3ikYUtdoO3MyLFDSkZDtaNdVmlkJ0tJ+PU4kjOaXAcoxVCmTmDJUpQoJECARjtC6Mp+pOND0D0ifwEaDhQmVKDOJKPGMUnJ5pZeaWkj8Z+CQo0USAA439U8QDhs2URAer1EX1Xkj8+oBZxJB8D5lXTZ+CPQbLjjTwB+xIn6s+LAksGjDaAME7AzuPY1hTn9Rc1nJHatEIPkvTj5PPA/8lB+voAjXlt5jF6uxTA8Fmn4B6aTvYygCj9ZsVKQsYrvAH7uBGPMf++jdz7kwhGzi6JEhTYQ4FdBQxLZmvgkG9UvPws0UwffUTfpeNzX1jsSN9njFUf783TswObAAyAI0pQ4BYK7ApgeAsGINEUD7CtLmKTJePPHCEZMOBUc4F2H04u4NbPAI2aZ2zkvs0VMOAYcitGTjpCek1ZWVrM6DpNZoEgLgPnLQpnft4hcTg1OkvlIfjEjuDejl4jysIpMCfAgItg4TbpIJhGO80LcKjhTU5/yWJEqva20uVktCmWaG5qpQ9HS+J8iigLpkDtgJHnsPRTZXqI2tLVAWj4NXQ9yIgzLLGeEMpdS0GfcULKleEBLxy7apmhifpRI2DkOSw9aYyLqDHpLRwFQNF0lqmNAfaecx44f4SwbSskZK0JMKxf75L0Zhdly3W4IpSj6ISiLIwCtQDGKpBAF2Gp6obOQrXp9HvnrKZn4OOAhyjZwhFTfOEgZiJGay0vTIFquaWpdz7IWgcY/epOgSkBA5bd0tPlVo05gARUZhNx2vUqrgKuA7A4V9JT3dTgXUnw2iXdp2uymgem9PMErOWFEPk3hn5jsrkZteGxAYMNRgg4Gyx/Y5nZc0i/iJLEpf8EbjU5YzEWzn84POknyD9hOg2S58ApcVDM3ArK0Jc3nGnBOBjjZ8I7dG5T2q+/YwAG4AAncVhK8+Z7CCfB29cOAu7X++lqMyY2SM4ZoYjFLGnHAeBWzrECgMVVkk5JQHHddF0v0vKJkhBVAEQOmPYFPQ3iCqLWNUVai4dUQ4EhAINN5HUS+WDNPwK9RK06iVUTBCAghjSJUQADIMG3eUhyajuAyOG2u1agxVMSeDSNjfkFXC7YtYEvdTylAGMdSPDm5a17mqTLZ0zsJv8EhpO7fQMYiCtsmLMkcd8uF8Z7fOZWbuONmJQdmvltAQNTIjoJ82LMSQNQIHLMlZuw8aCn8HoIu46Zl7HnnqSYSY9NGbaXFIvxwOTghReuneT1zOAwdgcxNgWMdT4HKP0AiaZ0dXOinmX9BvTyYpzDHMWqMeYAXxM7FGmM9qKNESjQFzDYQJgJ8TtoKmSUMiXmCN0ftAk4BLwd81B4dDCIGDW4nw9KgHh4UCCnQB/AQE6FLW8zIwIicz/dycLiGUs+Tjt4KIAi9tFiKdAVMNqUfcjwbK45b6JVCturJZ2Zxjd3MFzsIo+Bl6PAOsDgLYs9PWfLTZmJ+LFtCrtyo+n+JLglsmDhT5EHiVlQ266IVt2pEjWDAmsosAow2Ez4G+SsOTI8loG5vHEBBK+1b4sinYs7eizqoMBkFGgDDN6umEvzUnuaOZ95i9/rcmjOzR19soUSDQcFoEATYBDj8PyMPN7luTbKwe1Y9q02gEDXgvkTrshOKJsLh1QbvaM/C6ZADhjkOcBjzxesA2zKWnQVZsmAg2hyGINrMGDge6r0fAteVjH0XaWAB4ynZbkayASFGZUsS1MXA4kmJSVxChcnkAhwmHqmov2dpoABxsGSLnQyPxGHgMV7Jx49HITl8bSuIF7YEQFz9ySdmLzRfFCgHwUMMHI/iylzN1rODMDCR4Tiim2HDfUbZdQOCgQFilDAAIPISjM3ThWKjbgBN+GzV8FNWPBaLTqUIoSPhwQF5kgBA4ybXefHOrgG7gHrBgDBx3MTuxSTMsd1EX0OCjRSAMBABCArlBV/YDBcRylFIlYNvCv5bjpbxByn0EsENxELNihQIQUADBK7Xur6dpE7fOcQSZzaxUldtonxY+C3ffPbfBr4DQDBLfjvNu/KcJyqcFFEl4ICbRQAMDi0Bg6DI/yayk2S9ilAQrJjX+nMn+E4VYCo8YigwJgUMB3GGZKOSpmusZj8UNJl6VBeNjacA1yDcQ700TIq+evUM+6DOtxrTlRjjivaCgoEBQagwH8B11CK4DodBN8AAAAASUVORK5CYII='
  },
];

const formItemLayout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 10,
  },
};


class DocumentSignature extends React.Component {

  constructor() {
    super();
    this.state = {
      url: '',
      collapsed: false,
      searchText: '',
      searchedColumn: '',
      isModalVisible: false,
      pdfInfo: [],
      trimmedDataURL: null,
      activeDrags: 0,
      deltaPosition: {
        x: 0, y: 0
      },
      controlledPosition: {
        x: -400, y: 200
      },
      pencilEnabled: false,
      isShowpdfColumn: true,
      isShowSubmit: true,
      isLoading: false,
      documentDetailData: {},
      isToast: false,

      signatureData: [],
      signCount: 0,
      signImagePath: '',

      getRemark: '',
      btnDisable: false,
    };

    // this.sigPad = {}
    //  this.pdfjslibRef = React.forwardRef();
    this.pdfjslibRef = React.createRef();
    this.sigPad = React.createRef();
    this.addSign = this.addSign.bind(this);
    this.clearSign = this.clearSign.bind(this);
    this.enableHighlight = this.enableHighlight.bind(this);
    this.deleteSelectedObject = this.deleteSelectedObject.bind(this);
    this.printDocument = this.printDocument.bind(this);
    this.downloadDocument = this.downloadDocument.bind(this);
    this.setPdfFile = this.setPdfFile.bind(this);
    this.uploadPdfDocument = this.uploadPdfDocument.bind(this);
  }





  componentDidMount() {
    this.props.clearState();
    const { location } = this.props;
    if (this.props.location.state.documentInfo.childProcess === true) {
      this.props.getDocumentDetailV2Asyn(location.state.processId).then((res) => {

        if (res && res.data && res.data.signedPdf) {
          this.props.getIncryptedPDF(res.data.signedPdf).then((pdf_Data) => {

            let pdf_url = `${process.env.REACT_APP_SERVER_PDF_ENC_URL}/document/${res.data.signedPdf}.enc.unenc`;

            this.setState({ url: pdf_url, documentDetailData: res.data });
          });
        }

        // this.setState({ url: res.data.signedPdf, documentDetailData: res.data });
      });
    }
    else {
      this.props.getDocumentDetailAsyn(location.state.processId).then((res) => {
        // console.log('getDocumentDetailAsyn',res.data)
        //  localStorage.removeItem('documentDetailData');
        //  localStorage.setItem('documentDetailData', res.data);

        if (res && res.data && res.data.signedPdf) {
          this.props.getIncryptedPDF(res.data.signedPdf).then((pdf_Data) => {


            let pdf_url = `${process.env.REACT_APP_SERVER_PDF_ENC_URL}/document/${res.data.signedPdf}.enc.unenc`;

            this.setState({ url: pdf_url, documentDetailData: res.data });
          });
        }

        // this.setState({ url: res.data.signedPdf, documentDetailData: res.data });
        // this.setPdfFile(this.props.documentDetailData);
      });

    }
    //this.setPdfFile();
    this.props.getSignatureListAsyn().then((res) => {
      this.setState({ signatureData: res.data.data, signCount: res.data.count, signImagePath: res.data.path });
    });
  }

  componentWillUnmount() {
    this.setState({ trimmedDataURL: undefined });
    this.sigRef = {};
    // clearTimeout(this.intervalPdf);
    const { location } = this.props;
    if (this.state.documentDetailData && this.state.documentDetailData.signedPdf) {
      this.props.EncrptyPdfDataDelAsyn(this.state.documentDetailData.signedPdf);
    }
  }

  setPdfFile(documentDetailData) {
    // console.log('documentDetailData', documentDetailData)
    let pdfUrl = documentDetailData ? documentDetailData.signedPdf : '';
    // alert(pdfUrl)
    // this.setState({ url: pdfUrl });
  }

  // setPdfFile() { 
  //   const { location,getDocumentHighlights } = this.props;
  //  console.log(this.props)
  //   let pdfUrl = location.state?location.state.documentInfo.documentUpdatedData.processTimeLogs[0].pdfFile:'';
  //   this.setState({url:pdfUrl});
  //   }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  showModal = () => {
    this.setState({ isModalVisible: true });
  };

  handleOk = () => {
    this.setState({ isModalVisible: false });
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };

  downloadDocument() {
    this.pdfjslibRef.current.savePdfDoc('output.pdf')
  }

  printDocument() {
    this.pdfjslibRef.current.printPdfDoc('output')
  }
  addSign() {
    if (!this.sigPad.isEmpty()) {
      this.setState({ btnDisable: false });
      const simg = this.sigPad.getTrimmedCanvas().toDataURL('image/png');
      this.pdfjslibRef.current.eSignFn(simg);
    }
  }

  clearSign() {
    this.sigPad.clear();
  }

  enableHighlight() {
    // this.pdfjslibRef.current.enablePencil();
    // this.setState({pencilEnabled:!this.state.pencilEnabled})
  }

  deleteSelectedObject() {
    const confirm = Modal.confirm;
    let pdfjsref = this.pdfjslibRef.current;
    confirm({
      title: 'Are you sure ?',
      content: '',
      okText: 'Clear',
      onOk() {
        pdfjsref.deleteSelectedObject()
      },
      onCancel() { },
    });
    //if (confirm('Are you sure ?')) {this.pdfjslibRef.current.deleteSelectedObject();} 
  }

  hidePdfDiv = () => {
    this.setState({ isShowpdfColumn: false });
  }

  showPdfDiv = () => {
    this.setState({ isShowpdfColumn: true });
  }

  onChangeRemark = (e) => {
    this.setState({ getRemark: e.target.value });
  }

  uploadPdfDocument() {
    this.setState({ isLoading: true, btnDisable: false });
    this.setState({ isShowSubmit: false });
    // var myobj = document.getElementsByClassName("upper-canvas");
    // var myobj = document.getElementById('pdfjslib-container');
    // myobj.parentNode.removeChild(myobj);
    // console.log("clicked..", this.state.getRemark);
    // if (this.state.getRemark != "") {
    // const docUUID = this.props.documentDetailData.documentUpdatedData._id;
    // const templateUUID = this.props.documentDetailData.template_id;
    // const documentDetailData = localStorage.getItem('documentDetailData')?localStorage.getItem('documentDetailData'):this.state.documentDetailData;
    //console.log(this.state.documentDetailData)
    //console.log('docUUID='+docUUID,'templateUUID='+templateUUID)
    const docUUID = this.state.documentDetailData.documentUpdatedData._id;
    const templateUUID = this.state.documentDetailData.template_id;
    const blob = this.pdfjslibRef.current.getPdfDoc();
    var formData = new FormData();
    formData.append('pdfFile', blob);
    formData.append('document_uuid', docUUID);
    formData.append('template_uuid', templateUUID);
    // formData.append('remark', this.state.getRemark);
    formData.append('remark', 'System generated remark..!');

    if (this.props.location.state.documentInfo.childProcess === true) {
      this.props.UploadSignedDocumentV2Asyn(formData).then((res) => {
        if (res.code == 406) {
          toast.error(res.message.toUpperCase());
          this.setState({ isLoading: false });
        }
        else this.props.history.push('/dashboard');
      }).catch((err) => {
        // console.log(err.response.data.message)
        this.setState({ isLoading: false });
        if (err.response.data.code == 406) toast.error(err.response.data.message.toUpperCase());
      });

    }
    else {
      this.props.UploadSignedDocumentAsyn(formData).then((res) => {
        if (res.code == 406) {
          toast.error(res.message.toUpperCase());
          this.setState({ isLoading: false });
        }
        else this.props.history.push('/dashboard');
      }).catch((err) => {
        // console.log(err.response.data.message)
        this.setState({ isLoading: false });
        if (err.response.data.code == 406) toast.error(err.response.data.message.toUpperCase());
      });
    }

    // }

  }


  handleAddSign = (e, value) => {
    e.preventDefault();
    this.setState({ btnDisable: false });
    this.pdfjslibRef.current.eSignFn(value.base64);
  }

  goBack = () => {
    this.props.history.goBack();
  };


  render() {
    let documentTitle = this.state.documentDetailData && this.state.documentDetailData.processName ? this.state.documentDetailData.processName : '';
    return (
      <>
        <Container >
          <Form>
            <div className="site-layout-content"
              style={{ marginTop: 0, paddingTop: 0 }}
            //  style={{marginTop:5}}
            >
              <Spin indicator={antIcon} style={{ alignItems: 'center', justifyContent: 'center', justifyItems: 'center', textAlign: 'center', width: '100%', maxHeight: '100%', position: 'fixed', zIndex: 1111, left: 0, right: 0, top: '45%', bottom: 0 }} spinning={this.state.isLoading} />
              {this.state.isToast &&
                <Toaster
                  toastOptions={{
                    className: '',
                    style: {
                      border: '1px solid #713200',
                      padding: '16px',
                      color: '#713200',
                      marginTop: 50
                    },
                  }}
                >
                  {(t) => (
                    <ToastBar toast={t}>
                      {({ icon, message }) => (
                        <>
                          {icon}
                          {message}
                          {t.type !== 'loading' && (
                            <button onClick={() => toast.dismiss(t.id)}>X</button>
                          )}
                        </>
                      )}
                    </ToastBar>
                  )}
                </Toaster>
              }
              <div >
                <Row className="mySubmit" style={{ background:'#003360',   width: '100%',  paddingTop: 3, paddingBottom: 5 }} >
                  {this.state.isShowpdfColumn
                    ? <>
                      <Col span={4}>
                        {/* <h2 className="color-ffffff text-capitalize">{documentTitle}</h2> */}
                        <h2 className="color-ffffff text-capitalize">{localStorage.getItem("DOCREF")}</h2>
                      </Col>
                      <Col span={6} style={{ textAlign: 'right' }}>
                        <Space >
                          <Button onClick={this.deleteSelectedObject} style={{ borderColor: "#C1C1C1" }} type={'primary'} icon={<IoTrashBin style={{ marginBottom: -2 }} />} ghost> <span style={{ color: '#000' }}> &nbsp;Clear Selection</span></Button>
                        </Space>
                      </Col>
                    </>
                    : <>
    
                      <Col span={10}>
                        <h2 className="color-ffffff text-capitalize">{documentTitle}</h2>
                        </Col>
                      <Col span={7} style={{ textAlign: 'right' }}>
                        <Space >
                          <Button onClick={this.deleteSelectedObject} style={{ borderColor: "#C1C1C1" }} type={'primary'} icon={<IoTrashBin style={{ marginBottom: -2 }} />} ghost> <span style={{ color: '#000' }}> &nbsp;Clear Selection</span></Button>
                        </Space>
                      </Col>
                    </>
                  }
                  {/* <Col span={this.state.isShowpdfColumn?16:20}>
           <h2 >Requirement Application Form bill Johnson</h2>
         </Col> */}

                  <Col span={1}></Col>
                  {this.state.isShowpdfColumn &&
                    <Col span={13}>
                      <Row>
                        <Col span={28}>
                        <Link to="/dashboard">
  <Button type="primary" size="middle" style={{ marginRight: "10px" }} ghost>
    Cancel
  </Button>
</Link>
                          
                         
                          <Space>
                            <Button onClick={this.downloadDocument} style={{ borderColor: "#C1C1C1" }} type="primary" icon={<DownloadOutlined />} ghost><span style={{ color: '#000' }}>Download</span></Button>
                            <Button onClick={this.printDocument} style={{ borderColor: "#C1C1C1" }} type={'primary'} icon={<PrinterOutlined />} ghost><span style={{ color: '#000' }}>Print</span></Button>
                    {this.state.isShowSubmit==true &&         <Button onClick={() => this.uploadPdfDocument()} title={this.state.btnDisable ? 'Please Add Sign' : null} type="primary" size="middle" disabled={this.state.btnDisable} ghost>
                    Submit 
                  </Button>}
                  {this.state.isShowSubmit==false && <h3 style={{color:'#fff'}}><Spin></Spin> Submitting...</h3>}
                            </Space>
                           
                        </Col>
                        <Col span={8} style={{ textAlign: 'right' }}>
                          {/* <Space >
            <Button  onClick={this.deleteSelectedObject} style={{borderColor:"#C1C1C1"}} type={'primary'} icon={<IoTrashBin style={{marginBottom:-2}}/>} ghost> <span style={{color:'#000'}}> &nbsp;Clear Selection</span></Button>
            </Space> */}
                        </Col>
                      </Row>
                    </Col>
                  }
                </Row>
                <div className={styles.boxshadowclass} style={{ display: "flex", height: "111vh", backgroundColor: '#DFE0EB' }}>
                  <Row style={{ width: '100%', height: '100%' }} >

                    <Col span={this.state.isShowpdfColumn ? 16 : 23}>
                      {/* <Row>
               <Col span={24} >
               <Button style={{marginTop:10,float:'right',marginBottom:15}} onClick={this.printDocument}><DownloadOutlined/></Button>
               </Col>
           </Row> */}
                      <Row>
                        <Col span={24} style={{ width: '100%', height: "111vh", overflow: 'auto' }}>
                          <PdfjsComponent ref={this.pdfjslibRef} url={this.state.url} stye={{width:'100%'}} />
                        </Col>
                      </Row>
                    </Col>

                    <Col span={1}>
                      {this.state.isShowpdfColumn
                        ? <Button type="link" style={{ flex: 1, top: '50%', color: '#000' }} icon={<RightOutlined />} onClick={() => this.hidePdfDiv()}></Button>
                        : <Button type="link" style={{ flex: 1, top: '50%', color: '#000' }} icon={<LeftOutlined />} onClick={() => this.showPdfDiv()}></Button>
                      }

                    </Col>
                    {this.state.isShowpdfColumn &&
                      <Col span={7} className={styles.sidebar}>
                        {/* <Row style={{marginTop:10}}>
            <Col span={3}> </Col>
            <Col span={18}>  <Button style={{borderColor:"#C1C1C1"}} type="primary"  onClick={this.deleteSelectedObject}  ghost> <span style={{color:'#000'}}><IoTrashBin style={{marginBottom:-2}}  /> Clear Selection</span></Button></Col>
            <Col span={3}> </Col>
            </Row> */}
                        <Row style={{ marginTop: 10 }}>
                          {/* <Col span={3}> </Col> */}
                          <Col span={22} style={{ display: 'inline-block', margin: '0 auto', border: '1px solid #000', marginTop: 5, backgroundColor: '#fff' }}>
                            <SignatureCanvas id="signaturecanvascontainer" penColor='black' ref={(ref) => { this.sigPad = ref }}
                              canvasProps={{ width: 300, height: 200, className: 'sigCanvas' }} />
                          </Col>
                          {/* <Col span={3}> </Col> */}
                        </Row>
                        {/* <div id="signaturediv" style={{display:'inline-block',margin:'0 auto',border:'1px solid #000',marginTop:20,backgroundColor:'#fff'}}>
                  <SignatureCanvas penColor='black' ref={(ref) => { this.sigPad = ref }}
                  canvasProps={{width:200,height:200,className: 'sigCanvas'}} />
                  </div> */}
                        <Row style={{ marginTop: 10 }}>
                          {/* <Col span={3}> </Col> */}
                          <Col span={20} style={{ paddingLeft: '15px' }}>
                            <Space>
                              <Button style={{ borderColor: "#C1C1C1" }} type="primary" onClick={this.addSign} ghost><FaSignature style={{ marginBottom: -2 }} /><span style={{ color: '#000' }}> Add Signature</span></Button> &nbsp;
                              <Button style={{ borderColor: "#C1C1C1" }} type="primary" onClick={this.clearSign} ghost><MdClear style={{ marginBottom: -2 }} /><span style={{ color: '#000' }}> Clear</span></Button>
                            </Space>
                          </Col>
                          {/* <Col span={3}> </Col> */}
                        </Row>

                        {/* <Row>
                          <Col span={3}> </Col>
                          <Col span={18}>
                            <Form.Item
                              name="remark"
                              rules={[{ required: true, message: 'Please enter subject' }]}
                              requiredMark={'optional'} >
                              <TextArea onChange={this.onChangeRemark} ref={(e) => (this.getRemark = e)} required style={{ marginTop: 35, lineHeight: 1.2 }} rows={0} className="formInput" placeholder="Add Remark here.." />
                            </Form.Item>
                          </Col>
                        </Row> */}

                        <Row ><Col span={24} style={{ padding: "20px 10px 0px 15px" }}><h3 style={{ marginBottom: '0px', fontWeight: '700' }}>Saved Signature ({this.state.signCount ? this.state.signCount : 0})</h3></Col></Row>
                        <Row>
                          {/* <Col span={3}> </Col> */}
                          <Col span={24}>
                            <Space style={{ width: '100%' }}>

                              <List
                                className="document-signature-list"
                                itemLayout="horizontal"
                                dataSource={this.state.signatureData}
                                renderItem={item => (
                                  <List.Item actions={[<Button onClick={(e) => this.handleAddSign(e, item)} size={'small'} style={{ float: 'right', marginTop: 5, fontSize: 12 }} type={'primary'}>Add</Button>]}>

                                    <List.Item.Meta
                                      // avatar={<Image preview={false} src={this.state.signImagePath + item.signature} />}
                                      avatar={<Image preview={false} src={item.base64} />}
                                    />
                                  </List.Item>
                                )}
                              />
                            </Space>
                          </Col>
                          {/* <Col span={3}> </Col> */}
                        </Row>
                      </Col>
                    }
                  </Row>

                </div>

              </div>

              <Row
                style={{
                  padding: '16px 0px 24px 0px',
                  // borderLeft: "1px solid #dfe0eb",
                  // borderRight: "1px solid #dfe0eb",
                  // borderBottom: "1px solid #dfe0eb",
                }}
              >
                {/* <Col span="16">
                  <Button onClick={() => this.goBack()} type="primary" size="middle" style={{ marginRight: "10px" }} ghost>
                    Back
                  </Button>
                </Col> */}
            
              </Row>
              {/* <Row style={{ marginTop: 125, marginBottom: 125 }}><Col span={24}></Col></Row> */}

            </div>
          </Form>
        </Container>
      </>
    );
  }
}

//export default DocumentSignature;

const mapStateToProps = (state) => {
  return {
    response: state.documentsignature.response,
    documentDetailData: state.documenthighlights.documentDetailData,
    user: state.auth.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    UploadSignedDocumentAsyn: (data) => dispatch(UploadSignedDocumentAsyn(data)),
    UploadSignedDocumentV2Asyn: (data) => dispatch(UploadSignedDocumentV2Asyn(data)),
    getIncryptedPDF: (data) => dispatch(getIncryptedPDF(data)),
    EncrptyPdfDataDelAsyn: (data) => dispatch(EncrptyPdfDataDelAsyn(data)),
    clearState: () => dispatch(clearState()),
    clearAddResponseState: () => dispatch(clearAddResponseState()),
    getDocumentDetailAsyn: (data) => dispatch(getDocumentDetailAsyn(data)),
    getDocumentDetailV2Asyn: (data) => dispatch(getDocumentDetailV2Asyn(data)),
    unsetDocumentDetailStateAsync: () => dispatch(unsetDocumentDetailStateAsync()),
    getSignatureListAsyn: (data) => dispatch(getSignatureListAsyn(data)),
    clearSignatureListState: () => dispatch(clearSignatureListState()),

  }
};
export default connect(mapStateToProps, mapDispatchToProps)(DocumentSignature)